function cutLine(lastPoint,eventHandler,conf){
    PIXI.Container.call(this);
    this.width=1280;
    this.height=780;
    this.lastPoint=lastPoint;
    this.lastPointCur=[0,0];
    this.appJQ=conf.appJQ;

    conf=$.extend({
        img:"/gfx/place/gameninja/halloween/trail.png",
        width:1280,
        height:780,
        on_load:function(){}
    },conf);
    this.conf=conf;
    var loaderMain = new PIXI.loaders.Loader();
    loaderMain.add("trail",conf.img,{crossOrigin: true});

    this.rope_points=[];
    this.history_points=[];
    this.ropeSize=50;
    this.historySize=10;
    this.last_point_added=[0,0];
    this.eventHandler=eventHandler;

    loaderMain.load(function(loader, resources){
        conf.on_load();
    });
    this.eventHandler.one("moduleClear",function(){
        loaderMain.reset();
    });
}
cutLine.prototype = Object.create(PIXI.Container.prototype);
cutLine.prototype= $.extend(cutLine.prototype,{
    prepareContainer:function(){
        var can_add=0;
        var lastPointT=this.lastPointCur;
        var thc=this;
        function putPoint(e){
            if(can_add==0 || typeof e.data.global=="undefined" || !isFinite(e.data.global.x) || !isFinite(e.data.global.y)){
                return false;
            }
            lastPointT.splice(0,lastPointT.length,e.data.global.x,e.data.global.y);
        }
        function setPointZero(){
            lastPointT.splice(0,lastPointT.length,0,0);
        }

        var i;
        for(i = 0; i < this.historySize; i++){
            this.history_points.push([0,0]);
        }
        for(i = 0; i < this.ropeSize; i++){
            this.rope_points.push(new PIXI.Point(0,0));
        }

        var trailTexture=PIXI.utils.TextureCache["trail"];

        var rope = new PIXI.mesh.Rope(trailTexture, this.rope_points);

        rope.blendmode = PIXI.BLEND_MODES.ADD;

        this.addChild(rope);

        this.on("mousemove",function(e){
           putPoint(e);
        });
        this.on("touchmove",function(e){
           putPoint(e);
        });
        this.on("pointerdown",function(e){
            if(can_add==0){
                can_add=1;
                putPoint(e);
                thc.clearPoint();
            }
        });
        this.on("pointerup",function(e){
           can_add=0;
           setPointZero();
        });
        this.on("pointerupoutside",function(e){
           can_add=0;
           setPointZero();
        });
        this.eventHandler.on("mouseupAll",function(event){
            can_add=0;
            setPointZero();
            return false;
        });

        this.interactive=true;
        this.buttonMode = true;
        this.hitArea = new PIXI.Rectangle(0, 0, this.conf.width, this.conf.height);

        var mouseX,mouseY;
        var touchX,touchY;


        var canvas=this.appJQ[0];

        function getMousePos(e) {
            if (e.offsetX) {
                mouseX = e.offsetX;
                mouseY = e.offsetY;
            }
            else if (e.layerX) {
                mouseX = e.layerX;
                mouseY = e.layerY;
            }
            e.data={global:{x:mouseX,y:mouseY}};
         }

        function getTouchPos(e) {
            if(e.touches) {
                if (e.touches.length == 1) { // Only deal with one finger
                    var touch = e.touches[0]; // Get the information for finger #1
                    var off=$(touch.target).offset(),scale_top=1;
                    var offObj=$.takeScaleObj();
                    scale_top=1/offObj.scale;
                    touchX=(touch.pageX-off.left)*scale_top;
                    touchY=(touch.pageY-off.top)*scale_top;

                    e.data={global:{x:touchX,y:touchY}};
                }
            }
        }
        canvas.addEventListener('mousedown',
            function(e){
                if(can_add==0){
                    can_add=1;
                    putPoint(e);
                    thc.clearPoint();
                }
                e.preventDefault();
                return false;
            }
        , false);
        canvas.addEventListener('mousemove',
            function(e){
                getMousePos(e);
                putPoint(e);
                e.preventDefault();
                return false;
            },
        false);
        canvas.addEventListener('touchstart',
            function(e){
               if(can_add==0){
                    can_add=1;
                    getTouchPos(e);
                    putPoint(e);
                    thc.clearPoint();
                }
                e.preventDefault();
                return false;
            },
        false);
        canvas.addEventListener('touchmove',
            function(e){
                getTouchPos(e);
                putPoint(e);
                e.preventDefault();
                return false;
            }

        , false);
        canvas.addEventListener('touchend',
            function(e){
                can_add=0;
                setPointZero();
                e.preventDefault();
                return false;
            }
        , false);



    },
    init:function(app){
        app.stage.addChild(this);
        this.prepareContainer();
    },
    update:function(delta){
        if(this.lastPointCur[0]==0 && this.lastPointCur[1]==0){
            this.alpha=0;
            this.lastPoint.splice(0,this.lastPoint.length,0,0);
            return false;
        }
        var i;
        this.lastPoint.splice(0,this.lastPoint.length,Math.round(this.lastPointCur[0]),Math.round(this.lastPointCur[1]));
        this.last_point_added[0]=this.lastPoint[0];
        this.last_point_added[1]=this.lastPoint[1];

        this.history_points.pop();
        this.history_points.unshift([this.lastPoint[0],this.lastPoint[1]]);
        var history_arr_range=[],range_sum=0;
        var history_arr_need=[1];
        for(i=0;i<this.historySize-1;i++){
            var p1=this.history_points[i];
            var p2=this.history_points[i+1];
            var range=Math.abs(p1[0]-p2[0])+Math.abs(p1[1]-p2[1]);
            history_arr_range[i]=range;
            range_sum+=range;
        }
        if(range_sum==0){
            this.alpha=0;
        }
        else{
            this.alpha=1;

            var ropeSizeRemain=this.ropeSize+1-this.historySize,ropeSizeRemainMax=ropeSizeRemain;
            for(i=1;i<this.historySize-1;i++){
                var range=history_arr_range[i];
                var need=Math.floor(range/range_sum*ropeSizeRemainMax);
                ropeSizeRemain-=need;
                history_arr_need[i]=1+need;
            }
            history_arr_need[0]=ropeSizeRemain+1;

            var objSm=new Smooth(this.history_points);
            //Update the points to correspond with history.
            for(i=0;i<ropeSizeRemain;i++){
                var p = this.rope_points[i];
                var arr=this.history_points[0];
                p.x = arr[0];
                p.y = arr[1];
            }
            var k,k_max,cur_point_index=ropeSizeRemain;
            cur_point_index=0;
            for(i=0; i < this.historySize-1; i++){
                k_max=history_arr_need[i];
                for(k=1;k<=k_max;k++){
                    var p = this.rope_points[cur_point_index];
                    var arr=objSm(i+k/k_max);
                    p.x = arr[0];
                    p.y = arr[1];
                    cur_point_index++;
                }
            }
        }
    },
    clearPoint:function(){
        var arr=[this.lastPointCur[0],this.lastPointCur[1]],i,p;
        for(i=0;i<this.historySize;i++){
            this.history_points[i]=[arr[0],arr[1]];
        }
        for(i=0;i<this.ropeSize;i++){
            p=this.rope_points[i];
            p.x=arr[0];
            p.y=arr[1];

        }
    }
});
